export default __webpack_public_path__ + "static/media/2089.fb4d58a1.png";